module.exports = __webpack_public_path__ + "img/pro_two_6.aea0f12d.jpg";